import { render, staticRenderFns } from "./GPundFirmaSuche.vue?vue&type=template&id=4c71e733"
import script from "./GPundFirmaSuche.vue?vue&type=script&lang=js"
export * from "./GPundFirmaSuche.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports